/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { KTSVG } from '../../../../../_metronic/helpers'
import { searchSubstitut } from '../../../../utils/search';
import { SearchInput } from '../../../components/SearchInput';
//import { ModalCreateCredential } from '../../../portals/components/modalCreateCredential';
import { ModalAddUnitBranch } from '../ModalAddUnitBranch';
import { ModalDeleteUnitBranch } from '../ModalDeleteUnitBranch';
import { ModalDetailsUnitBranch } from '../ModalDetailsUnitBranch';
import { TableBody } from './TableBody';
import { useAuth } from '../../../../modules/auth';
import { SearchInputV3 } from '../../../components/SearchInputV3';
import useSize from '../../../../hooks/useSize';
import { getUnitBranchAll } from '../../../../services/unitBranchService';
import { useQuery } from 'react-query';
import { Loading } from '../../../components/Loadings/loading';
import { ModalTipoUnitBranch } from '../ModalTipoUnitBranch';


type Props = {
  className: string;
}

const TableUnitBranchs: React.FC<Props> = ({className}) => {
  
  const [mySearch, setMySearch] = useState<any[]>([]);
  const [control, setControl] = useState(false);
  const [showCreateAppModal, setShowCreateAppModal] = useState<boolean>(false)
  const [showCreateAppModalDelete, setShowCreateAppModalDelete] = useState<boolean>(false)
  const [showCreateAppModalDetails, setShowCreateAppModalDetails] = useState<boolean>(false)

  const [showCreateAppModalTipo, setShowCreateAppModalTipo] = useState<boolean>(false)

  const [myUnitBranch, setMyUnitBranch] = useState<any | null>(null);
  const [filterUnitBranch, setfilterUnitBranch] = useState<string>("");
  const user = useAuth();

  const {width: largura} = useSize();

  const { data: unitBranchs = [], isLoading: loadingUnitBranchs, refetch: refreshUnitBranchs } = useQuery<any[]>(
    ["getUnitBranchs", filterUnitBranch],
    async () => {
        const myUnitsBranchs = await getUnitBranchAll()
        return myUnitsBranchs
    },
    {
      onError: (error) => {
        console.log(error);
      },
    }
  );

  
  return (
    <div className={`card ${className}`} style={{height: largura > 1200 ? '72vh' : '68vh', paddingBottom: '1rem'}}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
       {/* <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>Lista de unidades ( Filiais )</span>
          <span className='text-muted mt-1 fw-semibold fs-7'>{unitBranchs.length} Unidade(s)</span>
        </h3>*/}
        <div 
          style={{
            display: 'flex', 
            flexWrap: 'wrap',
            gap: '1rem', 
            alignItems: 'center', 
            justifyContent: "space-between", 
            width: '100%'
          }}>
          {/* <SearchInput 
            className='form-control form-control-solid ps-14 bg-body'
            placeholder='Buscar Unidade Filial'
            myDate={unitBranchs}
            setMySearch={setMySearch}
            control={control}
            style={{width: largura < 1200 ? "100%" : "300px"}}
            setControl={setControl}
            searchParameter="companyName"
          /> */}

            <div style={{flex: '1'}}>
              <SearchInputV3
                className='form-control form-control-sm bg-light'
                placeholder={"Buscar por nome"}
                setMySearch={""}
                //setPagination={setPagination}
                style={{ 
                  width: largura < 1200 ? "60%" : largura < 1700 ? "200px" : "400px", 
                  height: '3.5rem'
                }}
              />
            </div>

            {user.currentUser && user.currentUser.role && user.currentUser.role.slug && user.currentUser.role.slug === 'EMPRESA' &&
            (<div
                className='card-toolbar'
                data-bs-toggle='tooltip'
                data-bs-placement='top'
                data-bs-trigger='hover'
                title='Click para adicionar uma unidade filial'
                style={largura < 1200 ? {width: '100%', display: 'flex', justifyContent: 'end'} : {}}
              >
                <a
                  onClick={() =>{setShowCreateAppModal(true)}}
                  href='#'
                  className='btn btn-sm btn-light-primary'
                  //data-bs-target='#kt_modal_create_unitBranch'

                >
                  <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                  Nova Unidade FILIAL
                </a>
            </div>)}
        </div>
        
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body py-3' style={largura < 1200 ? {height: '20rem', overflow: 'auto', paddingTop: '0rem'} : {overflow: 'auto'}}>
        {/* begin::Table container */}
        
        {loadingUnitBranchs ?
          <div style={{display: 'flex', justifyContent: 'center', height: '20rem', alignItems: 'center'}}>
            <Loading myClass='spinner-border' style={{width: '3rem', height: '3rem'}}/>
          </div>
        :
        <div className='table-responsive'>
          {/* begin::Table */}
          <table className='table table-row-dashed table-hover table-row-gray-300 align-middle gs-0 gy-4'>
            {/* begin::Table head */}
            <thead>
              <tr className='text-muted text-start fw-bolder fs-7 text-uppercase gs-0'>
                <th className='min-w-250px'>Nome</th>
                <th className='min-w-140px'>CNPJ</th>
                <th className='min-w-150px'>Endereço</th>
                <th className='min-w-140px'>Responsável</th>
                <th className='min-w-100px'>Tipo</th>
                <th className='min-w-100px text-end'>Actions</th>
              </tr>
            </thead>
            {/* end::Table head */}
            {/* begin::Table body */}
              {
                control === false ? (
                  <TableBody 
                    unitBranchs={unitBranchs} 
                    setMyUnitBranch={setMyUnitBranch}
                    setShowCreateAppModal={setShowCreateAppModal}
                    setShowCreateAppModalDelete={setShowCreateAppModalDelete}
                    setShowCreateAppModalDetails={setShowCreateAppModalDetails}
                    setShowCreateAppModalTipo={setShowCreateAppModalTipo}
                  />
                )
                : (
                  <TableBody 
                    unitBranchs={mySearch} 
                    setMyUnitBranch={setMyUnitBranch}
                    setShowCreateAppModal={setShowCreateAppModal}
                    setShowCreateAppModalDelete={setShowCreateAppModalDelete}
                    setShowCreateAppModalDetails={setShowCreateAppModalDetails}
                    setShowCreateAppModalTipo={setShowCreateAppModalTipo}
                  />
                )
              }
              
            {/* end::Table body */}
          </table>
          {/* end::Table */}
        </div>}

        {/* end::Table container */}
      </div>
        <ModalAddUnitBranch 
          show={showCreateAppModal}
          id={myUnitBranch ? myUnitBranch.id : undefined} 
          data={myUnitBranch ? myUnitBranch : undefined}
          handleClose={() => {
            setMyUnitBranch(null)
            setShowCreateAppModal(false)
            refreshUnitBranchs()
          }} 
        />
        <ModalDeleteUnitBranch 
          show={showCreateAppModalDelete}
          data={myUnitBranch}
          id={myUnitBranch ? myUnitBranch.id : undefined} 
          handleClose={() => {
            setMyUnitBranch(null)
            setShowCreateAppModalDelete(false)
            refreshUnitBranchs()
          }} 
        />

        <ModalTipoUnitBranch 
          show={showCreateAppModalTipo}
          data={myUnitBranch}
          id={myUnitBranch ? myUnitBranch.id : undefined} 
          handleClose={() => {
            setMyUnitBranch(null)
            setShowCreateAppModalTipo(false)
            refreshUnitBranchs()
          }} 
        />

        <ModalDetailsUnitBranch 
          show={showCreateAppModalDetails}
          id={myUnitBranch ? myUnitBranch.id : undefined} 
          handleClose={() => {
            setMyUnitBranch(null)
            setShowCreateAppModalDetails(false)
            refreshUnitBranchs()
          }} 
        />
      {/* begin::Body */}
    </div>
  )
}

export {TableUnitBranchs}
